"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createInterviewSdk = createInterviewSdk;
const generated_1 = require("../generated");
const sdkHelper_1 = require("./sdkHelper");
function createInterviewSdk(init, enhancer) {
    return _create(init, enhancer);
}
function _create(config, enhancer) {
    if (enhancer) {
        return enhancer(_create)(config);
    }
    const apiConfig = new generated_1.Configuration({
        basePath: config.baseUrl,
    });
    config.axios.interceptors.response.use((response) => {
        if (response.data && typeof response.data === 'object') {
            response.data = (0, sdkHelper_1.convertDates)(response.data);
        }
        return response;
    });
    return new generated_1.DefaultApi(apiConfig, config.baseUrl, config.axios);
}
//# sourceMappingURL=sdkProvider.js.map